<template>
  <a-row class="performer-projects-layout">
    <a-col flex="250px" class="performer-projects-layout__left-side">
      <SideBar :items="sidebarItems" />
    </a-col>
    <a-col flex="auto" class="performer-projects-layout__right-side">
      <div class="performer-projects-layout__header">
        <HeaderPartnerAccount />
      </div>
      <div ref="scrollElement" class="performer-projects-layout__content">
        <a-spin
          :spinning="spinning"
          class="custom-spinner"
          style="height: 100vh; top: 20%"
        >
          <slot></slot>
        </a-spin>
      </div>
    </a-col>
  </a-row>
</template>

<script setup>
  import { onBeforeUnmount, onMounted, ref } from 'vue';
  import SideBar from '@/components/sidebar/SideBar';
  import HeaderPartnerAccount from '@/components/header/HeaderPartnerAccount';
  import { debounce } from 'lodash-es';

  document.title = 'Цифровой университет. НГУ';

  defineProps({
    spinning: {
      type: Boolean,
      default: false,
    },
  });
  const emit = defineEmits(['scroll-bottom']);
  const scrollElement = ref(null);
  const scrollThreshold = 30;

  onMounted(() => {
    scrollElement.value.addEventListener('scroll', handleScroll);
  });

  onBeforeUnmount(() => {
    scrollElement.value.removeEventListener('scroll', handleScroll);
  });

  const handleScroll = debounce(() => {
    const elementHeight = scrollElement.value?.getBoundingClientRect().height;
    const scrollHeight = scrollElement.value?.scrollHeight;
    const scrollBottom = scrollElement.value?.scrollTop + elementHeight;

    if (scrollBottom + scrollThreshold > scrollHeight) {
      emit('scroll-bottom', scrollBottom);
    }
  }, 70);

  const sidebarItems = ref([
    {
      id: 1,
      text: 'Мои задачи',
      path: 'performer-tasks',
      hash: '#inwork',
      type: 'tasks',
      count: 0,
    },
    {
      id: 2,
      text: 'Мои проекты',
      path: 'performer-projects',
      hash: '#inwork',
      type: 'projects',
      count: 0,
    },
    {
      id: 3,
      text: 'Витрина',
      type: 'showcases',
      url: '/showcase',
    },
  ]);
</script>

<style lang="scss" scoped>
  @use '@/assets/styles/_colors.scss' as *;

  .performer-projects-layout {
    min-height: 100vh;
    flex-wrap: nowrap;
    overflow: hidden;

    .performer-projects-layout__right-side {
      height: 100vh;

      .performer-projects-layout__header {
        border-bottom: 1px solid $color-bg-secondary-grey;
        background-color: $color-bg-primary-white;
        position: sticky;
        padding: 17px 40px 17px 20px;
        top: 0;
        z-index: 1;
      }

      .performer-projects-layout__content {
        overflow-y: auto;
        height: 100%;
        padding: 30px 40px 0 20px;
      }
    }
  }
</style>
